module.exports.integrationTypes = {
    saleEndorsement: "SaleEndorsement",
    settingsOverrides: "SettingsOverrides"
}

module.exports.externalEntities = {
    saleEndorsement: {
        pkFBR: "PK.FBR",    // Pakistan: Federal Board of Revenue
        pkSRB: "PK.SRB",    // Pakistan: Sindh Revenue Board
        keKRA: "KE.KRA"     // Kenya: Kenya Revenue Authority
    },
    settingsOverrides: {
        countrySettings: "CountrySettings"
    }
}

module.exports.systemTypes =
{
    settingsOverrides: {
        franchisor: "Franchisor",
        property: "Property"
    },
}